import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "#0079BF";

function IconTrello({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12zM6 2.08H3.04a.96.96 0 0 0-.96.93v9.11c0 .52.413.943.93.96H6a.96.96 0 0 0 .96-.93V3.04a.96.96 0 0 0-.93-.96H6zm6.96 0H10a.96.96 0 0 0-.96.93v5.11c0 .52.413.943.93.96H12.96a.96.96 0 0 0 .96-.93V3.04a.96.96 0 0 0-.93-.96h-.03z"/>
        </svg>
    );
}

export default IconTrello;
